import { GERMANY_CENTER } from '@mopla/constants';
import { ILatLng } from '@mopla/data-models';

export class LatLng {
	public coord: ILatLng;

	constructor(input: ILatLng, public accuracy?: number) {
		/** Shallow-copy to avoid holding a reference to a frozen object (e.g. from Zustand/Immer store).
		 * The HERE Maps SDK mutates the coord object internally, which would throw
		 * "Cannot assign to read only property" if the original reference is frozen. */
		this.coord = { lat: input.lat, lng: input.lng };
	}

	public toString() {
		return `${this.coord.lat},${this.coord.lng}`;
	}
}

export const germanyCenter = new LatLng(GERMANY_CENTER);

/**
 * Calculates the distance between two coordinates using the Haversine formula
 * @param coord1 First coordinate
 * @param coord2 Second coordinate
 * @returns Distance in meters
 */
export function calculateDistance(coord1: LatLng, coord2: LatLng): number {
	const R = 6371e3; /** Earth radius in meters */
	const φ1 = (coord1.coord.lat * Math.PI) / 180;
	const φ2 = (coord2.coord.lat * Math.PI) / 180;
	const Δφ = ((coord2.coord.lat - coord1.coord.lat) * Math.PI) / 180;
	const Δλ = ((coord2.coord.lng - coord1.coord.lng) * Math.PI) / 180;

	const a =
		Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
		Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

	return R * c;
}
